import {Box, Divider, Flex, HStack, Text} from "@chakra-ui/react";
import {Link} from "react-router-dom";
import {ReactComponent as Logo} from "../../assets/icons/footer_logo.svg";
import {ReactComponent as Xicon} from "../../assets/icons/x_icon.svg";
import {ReactComponent as Linkedin} from "../../assets/icons/linkedin_icon.svg";
import {ReactComponent as Telegram} from "../../assets/icons/telegram_icon.svg";
import {ReactComponent as CopyRight} from "../../assets/icons/copyright_icon.svg";
import {FooterGradients} from "./FooterGradients";

export const DesktopFooter = () => {


    return (
        <Box
            as={'footer'}
            mt={'48px'}
            h={'310px'}
            w={'full'}
            position={'relative'}
            overflow={'hidden'}>
            <Flex
                pr={'20px'}
                pl={{base: '20px',md: '20px', lg : '145px'}}>
                <Box
                    alignItems={'start'}
                    mt={'24px'}>
                    <Flex
                        justifyContent={'center'}
                        w={'100%'}>
                        <Logo/>
                    </Flex>
                    <Text
                        fontSize={'14px'}
                        mt={'14px'}
                        color={'neutral.300'}>
                        Trade smarter, Grow faster
                    </Text>
                    <HStack
                        pt={'35px'}
                        justifyContent={'center'}
                        w={'100%'}
                        gap={'12px'}>
                        <Xicon cursor={'pointer'}/>
                        <Linkedin cursor={'pointer'}/>
                        <Telegram cursor={'pointer'}/>
                    </HStack>
                </Box>
                <Flex
                    ml={'63px'}
                    mt={'69px'}
                    color={'neutral.300'}
                    maxW={'1217px'}
                    w={'full'}
                    justifyContent={'space-between'}
                    alignItems={'start'}
                    zIndex={'999'}>
                    <Link fontSize={'18px'} to={'/'}>Home</Link>
                    <Link fontSize={'18px'} to={'/about'}>About</Link>
                    <Link fontSize={'18px'} to={'/features'}>Features</Link>
                    <Link fontSize={'18px'} to={'/terms'}>Terms of Service</Link>
                    <Box>
                        <Text fontSize={'18px'} color={'neutral.300'}>Contact Us</Text>
                        <Text mt={'32px'} fontSize={'14px'} color={'#ffffff'}>+1 (406) 555-0120</Text>
                        <Text mb={'24px'} fontSize={'14px'} color={'#ffffff'}>+1 (480) 555-0103</Text>
                        <Text fontSize={'14px'} color={'#ffffff'}>hellp@logoipsum.com</Text>
                    </Box>
                </Flex>
            </Flex>
            <Divider
                mt={'35px'}
                borderWidth={'1px'}
                borderColor={'neutral.900'}/>
            <Flex
                position={'absolute'}
                bottom={'20px'}
                fontSize={'12px'}
                justifyContent={'center'}
                w={'100%'}
                color={'neutral.600'}>
                <CopyRight/> 2025 Arbito. All Rights Reserved.
            </Flex>
            <FooterGradients />
        </Box>
    )
}